import { Environment } from '@amzn/xb-hooks';
import { Stages } from '@amzn/aws-tc-ilt-common';

export enum NodeEnvironment {
    TEST = 'test',
    DEVELOPMENT = 'development',
    BETA = 'beta',
    GAMMA = 'gamma',
    PROD = 'prod',
}

export const getNodeEnvironment = (environmentValue: string = process.env.NODE_ENV || ''): NodeEnvironment => {
    const environment = Object.keys(NodeEnvironment).filter((key) => key === environmentValue.toUpperCase())[0];

    if (!environment) {
        throw new Error(`Node environment [${environmentValue}] is not valid`);
    }
    return NodeEnvironment[environment as keyof typeof NodeEnvironment];
};

export const getStageEnvironment = (): Stages => {
    switch (getNodeEnvironment()) {
        case NodeEnvironment.DEVELOPMENT:
        case NodeEnvironment.TEST:
            return 'Dev';
        case NodeEnvironment.BETA:
            return 'Beta';
        case NodeEnvironment.GAMMA:
            return 'Gamma';
        case NodeEnvironment.PROD:
            return 'Prod';
    }
};

export const getXBEnvironment = (): Environment => {
    switch (getNodeEnvironment()) {
        case NodeEnvironment.DEVELOPMENT:
        case NodeEnvironment.TEST:
            return 'local';
        case NodeEnvironment.BETA:
            return 'beta';
        case NodeEnvironment.GAMMA:
            return 'gamma';
        case NodeEnvironment.PROD:
            return 'prod';
    }
};
